import styled from "styled-components";
import { H700, H800, T300, T400 } from "../Styles";
import Button from "../UI/Button";
import PiggyBank from "../UI/Icons/PiggyBank";
import SealCheck from "../UI/Icons/SealCheck";
import Buildings from "../UI/Icons/Buildings";
import GlobeHemesphereWest from "../UI/Icons/GlobeHemisphereWest";
import I18n from "i18n-js";

type AboutCardProp = {
  icon: JSX.Element;
  title: string;
  description: string;
}

const AboutGuestbookWrapper = styled.div`
  padding: 104px 120px;
  text-align: center;
  justify-items: center;

  ${({theme}) => theme.tablet`
    padding: 64px 24px; 
  `}
`;

const AboutGuestbookContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  width: 100%;
`;

const TopContent = styled.div`
  display: flex; 
  flex-direction: column;
  gap: 24px;
`;

const TitleWrapper = styled.div`
  display: flex; 
  flex-direction: column;
  gap: 16px;
`;

const AboutText = styled(H700)`
  font-family: Sentient;
  width: 720px;
  align-self: center;

  ${({theme}) => theme.tablet`
    width: 100%;
  `}
`;

const BottomContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 48px;
  padding: 24px 0;

  ${({theme}) => theme.tablet`
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 16px 0;
  `}
`;

const AboutCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
`;

const IconContainer = styled.div`
  margin-bottom: 16px;
  height: 40px;
  width: 40px;
`;

const CardTitle = styled(H800)`
  font-family: Sentient;
  margin-bottom: 8px;
`;

const AboutCard = ({
  icon,
  title,
  description
}: AboutCardProp) => {
  return (
    <AboutCardWrapper>
      <IconContainer>
        {icon}
      </IconContainer>
      <CardTitle>{title}</CardTitle>
      <T400>{description}</T400>
    </AboutCardWrapper>
  )
}

const AboutGuestbook = () => {
  const cardItems = [
    {
      icon: <SealCheck />,
      title: "4M+",
      description: I18n.t("views.static_pages.hotel_landing.about_guestbook.section_1.description"),
    },
    {
      icon: <PiggyBank size={40}/>,
      title: "$152M+",
      description: I18n.t("views.static_pages.hotel_landing.about_guestbook.section_2.description"),
    },
    {
      icon: <Buildings />,
      title: "900+",
      description: I18n.t("views.static_pages.hotel_landing.about_guestbook.section_3.description"),
    },
    {
      icon: <GlobeHemesphereWest />,
      title: "81",
      description: I18n.t("views.static_pages.hotel_landing.about_guestbook.section_4.description"),
    },
  ];

  return (
    <AboutGuestbookWrapper>
      <AboutGuestbookContent>
        <TopContent>
          <TitleWrapper>
            <T300 isStrong={true}>
              {I18n.t("views.static_pages.hotel_landing.about_guestbook.top_header", {
                the_guestbook: "The Guestbook"
              })} 
            </T300>
            <AboutText>
              {I18n.t("views.static_pages.hotel_landing.about_guestbook.header")}
            </AboutText>
          </TitleWrapper>
          <a href="https://theguestbook.com/how-it-works" target="_blank">
            <Button
              kind="primary"
              small={true}
              customStyling={`
                padding: 12px 24px;
                line-height: unset; 
                height: 100%; 
                justify-self: center;
              `}
            >
              {I18n.t("views.static_pages.hotel_landing.about_guestbook.button.learn_more")}
            </Button>
          </a>
        </TopContent>
        <BottomContent>
          {cardItems.map((item, idx) => (
            <AboutCard
              key={idx}
              icon={item.icon}
              title={item.title}
              description={item.description}
            /> 
          ))}
        </BottomContent>
      </AboutGuestbookContent>
    </AboutGuestbookWrapper>
  )
}

export default AboutGuestbook;